

































import {Component, Vue} from 'vue-property-decorator';
import EditDialog from './AdminUserEditDialog.vue';
import passwordDialog from './AdminUserSetPasswordEditDialog.vue';
import CFlexGrid from '@/components/base/flex-grid/CFlexGrid.vue';

@Component({
    components: {
        CFlexGrid,
        passwordDialog,
    },
})
export default class AdminUser extends Vue {
    private editDialog = EditDialog;

    onSetPassword(item: any) {
        const options = {
            saveCallback: async (data: any) => {
                try {
                    await this.setPassword(item.Id, data.password);
                    (this.$refs.passwordEditing as any).close();
                } catch (e) {
                    (this.$refs.passwordEditing as any).setupErrors(e?.response?.data?.errors);
                }
            },
        };
        this.$nextTick().then(() => {
            (this.$refs.passwordEditing as any).open({password: ''}, options);
        });
    }

    setPassword(id: any, password: string) {
        return this.$http.get(`${this.$api.administration.adminUser}/SetPassword`, {
            params: {
                id,
                password,
            },
            is400ErrorHandled: true,
        } as any);
    }
}
